import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SuperadminAuthProvider, useSuperadminAuth } from '../../context/SuperadminAuthContext';
import SuperadminLayout from '../../components/superadmin/SuperadminLayout';
import SuperAdminDashboard from './SuperAdminDashboard';
import SuperAdminShopsPage from './SuperAdminShopsPage';
import SuperAdminShopWorkspace from './SuperAdminShopWorkspace';
import ShopOverview from './ShopOverview';
import ShopUsageSummary from './ShopUsageSummary';
import ShopBookings from './ShopBookings';
import ShopBarbers from './ShopBarbers';
import ShopClients from './ShopClients';
import ShopAIImages from './ShopAIImages';
import SuperAdminProvisionPage from './SuperAdminProvisionPage';
import SuperAdminNotifications from './SuperAdminNotifications';
import SuperAdminProfile from './SuperAdminProfile';
import Users from './Users';
import AuditLogs from './AuditLogs';
import System from './System';

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-900">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
  </div>
);

const SuperadminContent = () => {
  const { user, loading, error, hasSuperadminAccess } = useSuperadminAuth();

  // Show loading spinner while fetching user data
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to appropriate page if not superadmin
  if (error || !user || !hasSuperadminAccess()) {
    // Redirect based on user role
    if (user) {
      if (['shop_admin', 'barber'].includes(user.role)) {
        return <Navigate to="/admin" replace />;
      } else if (user.role === 'client') {
        return <Navigate to="/app/book" replace />;
      }
    }
    return <Navigate to="/?auth=1" replace />;
  }

  return (
    <SuperadminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/superadmin/dashboard" replace />} />
        <Route path="/dashboard" element={<SuperAdminDashboard />} />
        <Route path="/shops" element={<SuperAdminShopsPage />} />
        <Route path="/shops/:id" element={<SuperAdminShopWorkspace />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<ShopOverview />} />
          <Route path="usage" element={<ShopUsageSummary />} />
          <Route path="bookings" element={<ShopBookings />} />
          <Route path="barbers" element={<ShopBarbers />} />
          <Route path="clients" element={<ShopClients />} />
          <Route path="ai-images" element={<ShopAIImages />} />
        </Route>
        <Route path="/provision" element={<SuperAdminProvisionPage />} />
        <Route path="/notifications" element={<SuperAdminNotifications />} />
        <Route path="/profile" element={<SuperAdminProfile />} />
        <Route path="/users" element={<Users />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
        <Route path="/system" element={<System />} />
        <Route path="*" element={<Navigate to="/superadmin/dashboard" replace />} />
      </Routes>
    </SuperadminLayout>
  );
};

const SuperadminWrapper = () => {
  return (
    <SuperadminAuthProvider>
      <SuperadminContent />
    </SuperadminAuthProvider>
  );
};

export default SuperadminWrapper;
